<template>
  <div class="DeepInfo flex flex-col h-screen bg-turquoise">
    <div class="logo-header-container ml-8 mt-8">
      <div class="logo-header flex">
        <div class="logo w-32">
          <img class="w-full" src="https://blissing.s3-us-west-1.amazonaws.com/img/blissing_UN_logo_icon_v02.png" alt="blissing blue image logo">
        </div>
        <div class="flex flex-col ml-4">
          <img class="blissing-logo" src="https://blissing.s3-us-west-1.amazonaws.com/img/BLISSING_BW.png" alt="blissing text logo">
          <span class="text-2xl text-left ml-1 font-bold border-4ads border-b-4 leading-none self-start mt-1 text-black">DEEP INFO FOR EXPERTS</span>
        </div>
      </div>
    </div>

    <GeneralIndex v-if="section == 'index'" />
    <GeneralSubOne v-if="section == 'sub-general-one'"
    :pdfUrlOne="pdfBaseUrl + pdfs.general_1_idea"
    :pdfUrlTwo="pdfBaseUrl + pdfs.general_1_result"
    :pdfUrlThree="pdfBaseUrl + pdfs.general_1_way" />
    <GeneralSubTwo v-if="section == 'sub-general-two'" :pdfUrl="pdfBaseUrl + pdfs.general_2" />
    <GeneralSubThree v-if="section == 'sub-general-three'" :pdfUrl="pdfBaseUrl + pdfs.general_3" />
    <GeneralSubFour v-if="section == 'sub-general-four'" :pdfUrl="pdfBaseUrl + pdfs.general_4" />
    <GeneralSubFive v-if="section == 'sub-general-five'" :pdfUrl="pdfBaseUrl + pdfs.general_5" />
    <GeneralSubSix v-if="section == 'sub-general-six'" :pdfUrl="pdfBaseUrl + pdfs.general_6" />
    <GeneralSubSeven v-if="section == 'sub-general-seven'" :pdfUrl="pdfBaseUrl + pdfs.general_7" />
    <GeneralSubEight v-if="section == 'sub-general-eight'" :pdfUrl="pdfBaseUrl + pdfs.general_8" />

    <div v-if="section == 'index'" class="bottom-text">
      <h1 class="font-bold italic">Part 2: General Information</h1>
    </div>

    <div @click="goBack()" class="h-16 w-16 absolute bottom-0 ml-10 mb-10 z-50">
      <img class="arrow up cursor-pointer" src="https://blissing.s3-us-west-1.amazonaws.com/img/Arrow-up.png" alt="arrow up">
    </div>

    <Navigation textColor="black"/>

  </div>
</template>

<script>
import GeneralIndex from "@/components/deepinfo/general/Index.vue";
import GeneralSubOne from "@/components/deepinfo/general/SubOne.vue";
import GeneralSubTwo from "@/components/deepinfo/general/SubTwo.vue";
import GeneralSubThree from "@/components/deepinfo/general/SubThree.vue";
import GeneralSubFour from "@/components/deepinfo/general/SubFour.vue";
import GeneralSubFive from "@/components/deepinfo/general/SubFive.vue";
import GeneralSubSix from "@/components/deepinfo/general/SubSix.vue";
import GeneralSubSeven from "@/components/deepinfo/general/SubSeven.vue";
import GeneralSubEight from "@/components/deepinfo/general/SubEight.vue";
import Navigation from "@/components/Navigation.vue";
import {mapState} from "vuex";

export default {
  name: "DeepInfoGeneral",
  components:{
    GeneralIndex,
    GeneralSubOne,
    GeneralSubTwo,
    GeneralSubThree,
    GeneralSubFour,
    GeneralSubFive,
    GeneralSubSix,
    GeneralSubSeven,
    GeneralSubEight,
    Navigation
  },
  data(){
    return{
      section: 'index',
      pdfs:{
        general_1_idea: 'deep_info/Preview+-+The+Idea.pdf',
        general_1_result: 'deep_info/Preview+-+The+Result.pdf',
        general_1_way: 'deep_info/Preview+-+The+Way.pdf',
        general_2: 'deep_info/Social+Media+%26+Inside+Media.pdf',
        general_3: 'deep_info/Next+Billion+Users.pdf',
        general_4: 'deep_info/Creative+Concept.pdf',
        general_5: 'deep_info/Guaranty.pdf',
        general_6: 'deep_info/Inner+Architecture+%2B+Rituale+%2B+Blissing+System+Architecture.pdf',
        general_7: 'deep_info/IAI+-+What+is+the+Target+%2B+Key+Groups.pdf',
        general_8: 'deep_info/Neuro-Rituals.pdf',
      }
    }
  },
  methods:{
    showCard(card){
      if (card != 'deep-info-main-menu') {
        this.section = card;
      } else {
        this.$router.push({name: 'DeepInfo'});
      }
    },
    goBack(){
      if (this.section == 'index') {
        this.$router.go(-1);
      }else {
        this.showCard('index');
      }
    }
  },
  computed: {
   ...mapState(["pdfBaseUrl"])
 },
  mounted(){
    Event.$on('clickedCard', (data) => {this.showCard(data)});
  }
}
</script>

<style lang="css" scoped>
.blissing-logo{
  width: 20rem;
}

</style>
